module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Contact ArrowHead")]), _vm._v(" "), _c('address', [_c('strong', [_vm._v("ArrowHead Economics, LLC")]), _vm._v(" "), _c('br'), _vm._v("\n        27121 Adonna Ct."), _c('br'), _vm._v("\n        Los Altos Hills, CA  94022"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-phone-alt"
  }), _vm._v(" (650) 948-8830"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-print"
  }), _vm._v(" (650) 948-3396"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-envelope"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:support@ArrowHeadEconomics.com"
    }
  }, [_vm._v(" Support")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2cdfd278", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cdfd278"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/contact/contact.vue.html
// module id = 1089
// module chunks = 0